export default __webpack_public_path__ + "static/media/foam-water-pour.fbc9287c.jpg";